import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const formatDate = (iso) => {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
};

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = 'Energy Insights Blog | Last Mile Advisors';
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = 'Expert insights on lowering energy costs, deregulated markets, and electricity procurement strategies from Last Mile Advisors.';

    axios.get(`${API}/api/blog/posts`)
      .then(res => setPosts(res.data.posts || []))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main className="page-content">
      <section className="page-header-with-image">
        <div className="page-header-overlay"></div>
        <div className="container page-header-content">
          <span className="overline">Energy Insights</span>
          <h1 className="page-title" style={{ marginTop: '0.5rem' }}>The Last Mile Blog</h1>
          <p className="page-subtitle">
            Practical strategies to lower your energy costs, navigate deregulated markets, and buy power like a pro.
          </p>
        </div>
      </section>

      <section className="blog-list-section">
        <div className="container">
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '4rem' }}>
              <Loader2 size={32} className="animate-spin" style={{ color: 'var(--teal)' }} />
            </div>
          ) : posts.length === 0 ? (
            <p style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '4rem 0' }}>No posts yet — check back soon.</p>
          ) : (
            <div className="blog-grid" data-testid="blog-grid">
              {posts.map((post) => (
                <Link to={`/blog/${post.slug}`} key={post.id} className="blog-card" data-testid={`blog-card-${post.slug}`}>
                  {post.cover_image && (
                    <div className="blog-card-image">
                      <img src={post.cover_image} alt={post.title} loading="lazy" />
                    </div>
                  )}
                  <div className="blog-card-body">
                    <div className="blog-card-meta">
                      <span className="blog-card-category">{post.category}</span>
                      <span className="blog-card-readtime"><Clock size={12} /> {post.read_time} min read</span>
                    </div>
                    <h2 className="blog-card-title">{post.title}</h2>
                    <p className="blog-card-excerpt">{post.excerpt}</p>
                    <div className="blog-card-footer">
                      <span className="blog-card-author">By {post.author} · {formatDate(post.published_at)}</span>
                      <span className="blog-card-readmore">Read more <ArrowRight size={14} /></span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
